class HyAnnouncementBar extends HTMLElement {

  constructor() {

    super();

    this.options = {
      selector: '.announcement',
      autoplay: 5000,
      blockSize: 4,
      layoutSize: 4,
      layout: "grid-4 grid-portable-3 grid-lap-2",
      ...JSON.parse(this.dataset.options),
      breakPoints: [
        { name: "laptop", value: 1280 },
        { name: "portable", value: 1023 },
        { name: "lap", value: 767 }
      ],
    }

    this.interval = null;
    this.slider = null;
    this.slides = null;
  }
  connectedCallback() {
    this.setEventListeners();
    this.initSlider();
  }
  setEventListeners() {
    window.addEventListener('resize', this.initSlider.bind(this));
  }
  initSlider() {
    clearTimeout(this.interval);
    let layoutSize = this.options.layoutSize;

    const currentWindowWidth = window.innerWidth;
    const layouts = this.options.layout.split(' ');
    const currentUsedBreakPoint = this.options.breakPoints
        .filter( b => currentWindowWidth <= b.value )
        .sort(( a, b ) => a.value - b.value )
        .shift();

    const relevantLayout = currentUsedBreakPoint && layouts.find( layout => layout.includes( currentUsedBreakPoint.name ) );

    if (relevantLayout) {
      layoutSize = parseInt( relevantLayout.split('-').pop() );
    }

    if ( this.options.blockSize > layoutSize ) {
      this.changeSlide.call(this)
    } else {
      clearInterval(this.interval);
    }
  }
  changeSlide() {
    this.slider = this.firstElementChild;
    this.slides = Array.from(this.querySelectorAll(this.options.selector));

    if ( this.slides.length > this.options.blockSize ) {
      const elementForRemove = this.slides.shift();

      try {
        this.slider.removeChild( elementForRemove );
      } catch(e) {
        console.error(elementForRemove);
        return
      }
    }

    const previousSlide = this.slides[0];
    this.slider.appendChild(previousSlide.cloneNode(true));
    const moveLeft = this.slides[1].offsetLeft / this.options.autoplay * 10;
    let newPosition = 0;

    const moveSmooth = () => {

      if ( (newPosition + moveLeft) < this.slides[1].offsetLeft ) {
        newPosition += moveLeft;
        this.slider.style.left = `-${ newPosition }px`;
      } else {
        clearInterval(this.interval);
        this.changeSlide.call(this);
      }
    }

    this.interval = setInterval(moveSmooth.bind(this), 10 )
  }
}

if ( typeof customElements.get('hy-announcement-bar') == 'undefined' ) {
  customElements.define('hy-announcement-bar', HyAnnouncementBar);
}